import {Injectable, Injector} from "@angular/core";

import {ReportError} from "app/app.service";
import {BaseListService, BatchResponse} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";

@Injectable()
export class TemplateJobsListService extends BaseListService<Models.TemplateJobListRequest, Models.BatchRequest, Models.TemplateJobItemResponse>
{
    constructor(inj: Injector)
    {
        super(inj, Models.TemplateJobItemResponse);
    }

    @ReportError
    public list(listReq: Models.TemplateJobListRequest): Promise<Models.ListResponse>
    {
        return this.app.domain.apis.templates.v2ListTemplateJobs(listReq) as unknown as Promise<Models.ListResponse>;
    }

    @ReportError
    public view(jobId: string): Promise<Models.TemplateJobItemResponse>
    {
        return this.app.domain.apis.templates.v2GetTemplateJob(jobId);
    }

    @ReportError
    public rerun(jobId: string,
                 req: Models.TemplateJobRerunRequest): Promise<Models.TemplateV2ExecuteResponse>
    {
        return this.app.domain.apis.templates.v2RerunTemplateJob(jobId, req);
    }

    @ReportError
    public archive(jobIds: string[]): Promise<boolean>
    {
        return this.app.domain.apis.templates.v2ArchiveTemplateJobs(Models.TemplateJobArchiveRequest.newInstance({job_ids: jobIds}));
    }

    @ReportError
    public unarchive(jobIds: string[]): Promise<boolean>
    {
        return this.app.domain.apis.templates.v2UnarchiveTemplateJobs(Models.TemplateJobArchiveRequest.newInstance({job_ids: jobIds}));
    }

    @ReportError
    protected async getBatchResponseImpl(req: Models.BatchRequest): Promise<BatchResponse<Models.TemplateJobItemResponse>>
    {
        if (!req?.ids?.length) return {results: {}};

        const response = await this.app.domain.apis.templates.v2BatchTemplateJobs(Models.TemplateJobBatchRequest.newInstance({job_ids: req.ids}));
        return {results: response?.results ?? {}};
    }

    protected createBatchRequest(listReq: Models.TemplateJobListRequest,
                                 ids: string[]): Models.BatchRequest
    {
        return Models.BatchRequest.newInstance({ids: ids ?? []});
    }
}
